import { put, takeEvery } from 'redux-saga/effects'
import {
  loadOnsiteScript,
  getFormId,
  getProvisions,
  showForm,
  onScriptLoaded,
  setHostingElementProps,
  createSimulationIframeContainer,
  injectOnsiteScriptIntoContext,
  getHostingElementId,
  setHostingElementForMobile
} from '../services/onsiteService';
import { getUrlParam, getUrlPrefix } from '../utils';
import { fetchCustomParams } from '../actions/customParamsActions';
import { setAppReady, setAppError } from '../actions/appActions';
import { APP_INIT, APP_SET_SETTINGS, APP_SET_PROVISIONS, CP_INIT } from '../constants/actionTypes';

function* initHandler() {
  try {
    const propertyType = getUrlParam('propertyType');
    const formUuid = getUrlParam('formUuid');
    const propertyId = getUrlParam('propertyId');
    const versionToPresent = getUrlParam('versionToPresent');
    const isShowToggle = getUrlParam('isShowToggle') === 'true';

    const isDraft = getUrlParam('isDraft') === 'true';
    const shownMode = getUrlParam('shownMode');
    const relatedUuid = getUrlParam('relatedUuid');

    let deviceType;
    let contextWindow = window;
    const shouldSimulateMobile = !navigator.userAgent.includes('Mobile');
    if (shouldSimulateMobile) {
      deviceType = getUrlParam('deviceType');
      document.body.classList.add(`neb-device-${deviceType}`);
    }

    if (!deviceType || deviceType === 'desktop') {
      loadOnsiteScript(propertyId, formUuid, versionToPresent, isDraft);
      yield put({ type: CP_INIT, payload: { contextWindow } });
    } else {
      contextWindow = yield createSimulationIframeContainer();
      yield put({ type: CP_INIT, payload: { contextWindow } });
      injectOnsiteScriptIntoContext(contextWindow, propertyId, formUuid, versionToPresent, isDraft);
    }

    yield new Promise(resolve => contextWindow.addEventListener('neb_OnsiteLoaded', resolve));
    onScriptLoaded(contextWindow);

    yield put({ type: APP_SET_PROVISIONS, payload: { provisions: getProvisions() } });
    yield put(setAppReady());
    yield put(fetchCustomParams());

    const appSettings = {
      formUuid,
      urlPrefix: getUrlPrefix(),
      propertyType: propertyType,
      propertyId,
      versionToPresent,
      isShowToggle,
      isDraft,
      shownMode,
      relatedUuid,
      deviceType
    };
    const formId = getFormId();
    yield put({ type: APP_SET_SETTINGS, payload: appSettings });
    // Force React to flush the update before continuing
    yield new Promise(resolve => setTimeout(resolve, 0));
    if (deviceType && deviceType !== 'desktop') {
      setHostingElementForMobile(contextWindow, getHostingElementId(formId));
    } else {
      yield setHostingElementProps(formId);
    }
    yield showForm(contextWindow, formId, propertyType, isDraft);
  } catch (e) {
    yield put(setAppError(e));
  }
}

function* onsiteSaga(dispatch) {
  yield takeEvery(APP_INIT, initHandler);
}


export default onsiteSaga;
